/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringPointValueDTO
 */
export interface StringPointValueDTO {
    /**
     * 
     * @type {number}
     * @memberof StringPointValueDTO
     */
    step: number;
    /**
     * 
     * @type {number}
     * @memberof StringPointValueDTO
     */
    timestampMillis: number;
    /**
     * 
     * @type {string}
     * @memberof StringPointValueDTO
     */
    value: string;
}

/**
 * Check if a given object implements the StringPointValueDTO interface.
 */
export function instanceOfStringPointValueDTO(value: object): value is StringPointValueDTO {
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('timestampMillis' in value) || value['timestampMillis'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function StringPointValueDTOFromJSON(json: any): StringPointValueDTO {
    return StringPointValueDTOFromJSONTyped(json, false);
}

export function StringPointValueDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringPointValueDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'step': json['step'],
        'timestampMillis': json['timestampMillis'],
        'value': json['value'],
    };
}

export function StringPointValueDTOToJSON(value?: StringPointValueDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'step': value['step'],
        'timestampMillis': value['timestampMillis'],
        'value': value['value'],
    };
}

